import React from 'react'
import PropTypes from 'prop-types';
import Element from './Element';

function AllElements(
    {
        id,
        formikProps,
        elements,
        disabled
    }) {
    return elements.map((item, i) => {
        const elId = Boolean(item.id) && Boolean(id) ? `${id}.${item.id}` : undefined;
        return (
            <Element
                key={i}
                formikProps={formikProps}
                title={item.title}
                disabled={item.type === 'disabled' && disabled}
                id={elId}
                description={item.description}
            />
        )
    })
}

AllElements.propTypes = {
    classes: PropTypes.any,
}

export default AllElements;